export default "__VITE_ASSET__CWgGk5H3__"